export function setServicesTypes (state, servicesTypes) {
  state.servicesTypes = servicesTypes
}
